import {AbstractControl} from '@angular/forms';
import * as moment from 'moment';

export class DateValidator {
  static dateVaidator(AC: AbstractControl) {
    if (AC && AC.value && !moment(AC.value, 'YYYY-MM-DD', true).isValid()) {
      return {dateVaidator: true};
    }
    return null;
  }

  // Expiry date validation
  static ExpiryDate(AC: AbstractControl) {
    const month = AC.get('expiryDate').get('month').value;
    const year = AC.get('expiryDate').get('year').value;
    if (year && month) {
      const yearD = '20' + year;
      const monthD = month;
      const dayD = monthD === 2 || monthD === '02' ? 28 : 30;
      const dateValue = yearD + '-' + monthD + '-' + dayD;
      const selectedDate = moment(`${dateValue}`, `YYYY-MM-DD`);
      const todayDate = moment();
      const duration = moment.duration(selectedDate.diff(todayDate));
      const diff = duration.as('day');
      // tslint:disable-next-line:use-isnan
      if (Math.sign(diff) === -1 || Math.sign(diff) === NaN) {
        AC.get('expiryDate').setErrors( {ExpiryDate: true} );
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}
